<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col-12.my-header.font-weight-bold Настройки дизайна
  .container.mt-5
    .white_block
      .inputModule
        input-module(
          type="text",
          title="Название хаба",
          v-model="settings.name",
          placeholder="ActidHub"
        )
      .inputModule
        input-module(
          type="text",
          title="Домен личного кабинета",
          v-model="settings.domain",
          placeholder="my.actid.ru"
        )
      .inputModule
        input-module(
          type="image",
          title="Иконка в табе (favicon)",
          v-model="settings.favicon"
        )
      .inputModule
        input-module(
          type="image",
          title="Логотип в личном кабинете",
          v-model="settings.logo"
        )
      button.styled(@click="saveSettings") Сохранить настройки
</template>
<script>
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {},

  data() {
    return {
      settings: {
        logo: "",
        favicon: "",
        name: "",
        domain: "",
      },
    };
  },

  computed: {},

  mounted() {
    this.getSetting();
  },

  methods: {
    async getSetting() {
      let settings = (await apiDriver.admin.franchise.getSettings()).settings;
      this.settings = settings;
    },
    async saveSettings() {
      this.$toast.success("Настройки успешно сохранены!");
      await apiDriver.admin.franchise.saveSettings(this.settings);
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.inputModule {
  margin-bottom: 10px;
}
</style>
